export const HE = {
  "Open document": "××¡×× ×¤×ª××",
  "Upload file": "××¢×× ×§×××¥",
  "Drop file here to upload": "××¨××§ ××ª ××§×××¥ ××× ×××¢×××",
  "Disc": "×××¡×§",
  "URL": "××ª×××ª URL",
  "FILE": "×§×Ö¹×Ö¶×¥",
  "SIZE": "××××",
  "MB": "MB",
  "KB": "KB",
  "Bytes": "××ª××",
  "Loading... Please wait.": "×××¢× ×× × ×××ª×.",
  "Fit Width": "×¨××× ××ª×××",
  "Fit Height": "××ª×××ª ××××",
  "Password protected document": "××¡×× ××××× ××××¦×¢××ª ×¡××¡××",
  "Password": "×¡××¡××",
  "Open": "×Ö´×¤Ö°×ª×Ö¹×Ö·",
  "Password Required": "× ××¨×©×ª ×¡××¡××",
  "Incorrect password": "×¡××¡×× ×× × ××× ×",
  "Error": "×©×Ö°×Ö´××Ö¸×",
  "Something went wrong": "××©×× ××©×ª××©",
  "Server is not available": "××©×¨×ª ××× × ××××",
  "of": "×©×Ö¶×",
  "Please wait...": "×××ª× ×××§×©×..."
};
